import { useState, useEffect } from "react";
import { useFetch } from "../../../common/hooks/useFetch.js";
import { getReportQuarterlyMaintenanceService } from "../services/getReportQuarterlyMaintenance.service.js";

export const useReportQuarterlyMaintenance = (filters) => {
  const fetchData = useFetch();
  const [report, setReport] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchReport = async () => {
      try {
        setLoading(true);
        const response = await getReportQuarterlyMaintenanceService(fetchData)({
          filters,
        });
        setReport(response);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.startDate, filters.endDate]);

  return {
    report,
    loading,
  };
};
